module.exports = __webpack_public_path__ + "img/arrowdown.d0483f37.svg";